import { render, staticRenderFns } from "./ActivityWsVideoDisappearing.vue?vue&type=template&id=0f925c12&scoped=true"
import script from "./ActivityWsVideoDisappearing.vue?vue&type=script&lang=ts"
export * from "./ActivityWsVideoDisappearing.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsVideoDisappearing.vue?vue&type=style&index=0&id=0f925c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f925c12",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWsVideoDisappearing.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports